import { Expense } from "@finway-group/shared/lib/models"
import { isDiscountExpired } from "@finway-group/shared/lib/utils/expense.discount.utils"

export const getClassNameForDiscountHighlight = (expense: Expense) => {
    if (expense.isSuccessfullyProcessed()) return "finway-discount-highlight-used"
    if (isDiscountExpired(expense)) return "finway-discount-highlight-expired"
    return "finway-discount-highlight"
}
